import { Mail, Facebook, Instagram, Globe, MapPin, Heart } from "lucide-react";
import logo from "@/assets/logo.png";
import { CONTACT } from "@/lib/site";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative bg-[#0A0612] border-t border-[#D4AF37]/20 pt-20 pb-10 px-6 sm:px-10">
      <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <img src={logo} alt="The Change Center Church" className="h-12 w-12 object-cover rounded-lg border border-[#D4AF37]/40" />
            <div className="leading-tight">
              <p className="font-display text-lg gold-text font-semibold">The Change Center</p>
              <p className="text-[10px] uppercase tracking-[0.3em] text-[#A19CA8]">Church · Atlanta</p>
            </div>
          </div>
          <p className="text-[#A19CA8] leading-relaxed text-sm">
            A movement of transformation, worship and purpose — coming soon to Clayton County, Georgia.
          </p>
        </div>

        <div>
          <p className="text-sm uppercase tracking-[0.25em] text-[#D4AF37] mb-5">Connect</p>
          <ul className="space-y-4">
            <li>
              <a
                href={`mailto:${CONTACT.email}`}
                data-testid="footer-email"
                className="flex items-center gap-3 text-[#A19CA8] hover:text-[#D4AF37] transition-colors"
              >
                <Mail className="h-5 w-5 text-[#D4AF37]" />
                {CONTACT.email}
              </a>
            </li>
            <li>
              <a
                href={CONTACT.facebookUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                className="flex items-center gap-3 text-[#A19CA8] hover:text-[#D4AF37] transition-colors"
              >
                <Facebook className="h-5 w-5 text-[#D4AF37]" />
                @{CONTACT.facebook}
              </a>
            </li>
            <li>
              <a
                href={CONTACT.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="flex items-center gap-3 text-[#A19CA8] hover:text-[#D4AF37] transition-colors"
              >
                <Instagram className="h-5 w-5 text-[#D4AF37]" />
                @{CONTACT.instagram}
              </a>
            </li>
            <li>
              <a
                href={CONTACT.websiteUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-website"
                className="flex items-center gap-3 text-[#A19CA8] hover:text-[#D4AF37] transition-colors"
              >
                <Globe className="h-5 w-5 text-[#D4AF37]" />
                {CONTACT.website}
              </a>
            </li>
            <li className="flex items-center gap-3 text-[#A19CA8]">
              <MapPin className="h-5 w-5 text-[#D4AF37]" />
              {CONTACT.location}
            </li>
          </ul>
        </div>

        <div>
          <p className="text-sm uppercase tracking-[0.25em] text-[#D4AF37] mb-5">Launch</p>
          <p className="font-display text-2xl text-[#F9F6F0] mb-2">{CONTACT.launchWindow}</p>
          <p className="text-[#A19CA8] text-sm mb-6">Be among the first to join the journey.</p>
          <a
            href="#involved"
            data-testid="footer-cta"
            className="inline-flex bg-gradient-to-r from-[#D4AF37] to-[#B5952F] text-[#06040A] font-semibold uppercase tracking-wider text-xs px-6 py-3 hover:from-[#F3D56D] hover:to-[#D4AF37] transition-all"
          >
            Get Involved
          </a>
        </div>
      </div>

      <div className="max-w-6xl mx-auto mt-16 pt-8 border-t border-[#D4AF37]/10 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-[#A19CA8]/70 text-xs">
          © {new Date().getFullYear()} The Change Center Church Atlanta. All rights reserved.
        </p>
        <p className="text-[#A19CA8]/70 text-xs flex items-center gap-1.5">
          Built with <Heart className="h-3.5 w-3.5 text-[#D4AF37]" /> for the Kingdom
        </p>
      </div>
    </footer>
  );
};
